import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { subscriptionRequest } from '../MyProfile/Subscription/subscriptionApi';
import { getStandardBalance } from './aiApi';

const DAY_MS = 86400000;
const TRIAL_DAYS = 7;

// Display-only seven-day public trial banner for the Dashboard header: remaining
// days, a small progress indicator and the recorded credit allowance. It grants nothing
// and never changes billing state; View Subscription opens Profile → Subscription.
export default function TrialCountdown({ onViewSubscription }) {
  const [trial, setTrial] = useState(null);
  const [balance, setBalance] = useState(null);
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    let mounted = true;
    const refreshBalance = () => getStandardBalance().then(data => { if (mounted) setBalance(data); }).catch(() => {});
    const onBalance = event => { if (mounted) setBalance(event.detail); };
    subscriptionRequest().then(data => {
      const t = data?.publicTrial;
      if (mounted && t?.enrolled && t.status === 'trialing' && Number.isFinite(t.trialStart) && Number.isFinite(t.trialEnd)) {
        setTrial({ start: t.trialStart * 1000, end: t.trialEnd * 1000 });
        refreshBalance();
      }
    }).catch(() => {});
    const timer = window.setInterval(() => setNow(Date.now()), 60000);
    window.addEventListener('morphosys:ai-balance', onBalance);
    window.addEventListener('focus', refreshBalance);
    return () => { mounted = false; window.clearInterval(timer); window.removeEventListener('morphosys:ai-balance', onBalance); window.removeEventListener('focus', refreshBalance); };
  }, []);
  const remaining = trial ? Math.max(1, Math.min(TRIAL_DAYS, Math.ceil((trial.end - now) / DAY_MS))) : 0;
  const progress = trial ? Math.max(0, Math.min(1, (now - trial.start) / (TRIAL_DAYS * DAY_MS))) : 0;
  if (!trial || now >= trial.end) return null;
  const recordedBalance = balance?.mode === 'public-trial' && Number.isFinite(balance.allowance) && Number.isFinite(balance.remaining);
  return (
    <div role="status" aria-label="Seven-day free trial" className="trial-countdown mt-3 border rounded-lg px-4 py-3 bg-white" style={{ borderColor: 'var(--dashboard-border)' }}>
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
        <div className="flex items-center gap-3 min-w-0">
          <span className="rounded-full px-2 py-[3px] text-[11px] font-bold whitespace-nowrap" style={{ background: 'var(--dashboard-tint)', color: 'var(--dashboard-primary)' }}>Free trial</span>
          <p className="text-[14px] font-bold whitespace-nowrap">{remaining} {remaining === 1 ? 'day' : 'days'} remaining</p>
          <div role="progressbar" aria-label="Trial progress" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(progress * 100)} className="w-16 sm:w-24 lg:w-32 h-1.5 rounded-full overflow-hidden shrink-0" style={{ background: 'var(--dashboard-border)' }}>
            <div className="h-full rounded-full" style={{ width: `${Math.round(progress * 100)}%`, background: 'var(--dashboard-primary)' }} />
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
          <p className="dashboard-muted text-[13px]">Your free trial includes {recordedBalance ? balance.allowance : 20} AI credits.{recordedBalance ? ` ${balance.remaining} remaining.` : ''}</p>
          <Button type="link" size="small" onClick={onViewSubscription} className="!px-0 h-auto font-bold text-[13px]">View Subscription</Button>
        </div>
      </div>
    </div>
  );
}
